import { Box, Circle, Text } from '@factorialco/deprecated-design-system'
import { PointTooltipProps, Serie } from '@nivo/line'

import { ChartData } from 'modules/finance/components/FinancialWorkspace/components/Table/types'

import { CentToFormattedAmount, findHoveredPoints } from './helpers'

const Tooltip = (
  series: Serie[],
  chartData: ChartData[],
  toAmount: (value: number) => CentToFormattedAmount
) => {
  const Component = ({ point }: PointTooltipProps) => {
    if (point.data.xFormatted !== 'End' && point.data.xFormatted !== 'Start') {
      const points = findHoveredPoints(point, series)

      return (
        <Box
          gap="s8"
          padding="s12"
          background="white"
          borderRadius={{ all: 'abs016' }}
          style={{ boxShadow: '0px 4px 20px 0px #0D162514' }}
          border={{ all: { color: 'grey200', width: 's1', style: 'solid' } }}
        >
          <Text.Normal color="grey1000" weight="bold" size="100">
            {`${points[0]?.x}`}
          </Text.Normal>
          {points.map(({ y, serieId }) => {
            const category = chartData.find((obj) => obj.serieId === serieId)
            return (
              <Box
                gap="s32"
                key={serieId}
                flexDirection="row"
                alignItems="center"
                justifyContent="spaceBetween"
              >
                <Box gap="s8" key={serieId} flexDirection="row" alignItems="center">
                  <Circle size={8} color={category?.pointColor} />
                  <Text.Normal size="100">{category?.serieId}</Text.Normal>
                </Box>
                <Text.Normal color="grey1000" size="100">
                  {`${toAmount(Number(y)).amount}`}
                </Text.Normal>
              </Box>
            )
          })}
        </Box>
      )
    }
  }

  return Component
}

export { Tooltip }
